import fetch from "../../utils/fetch";
import { defBreadcrumb, blogBreadcrumb } from "src/data/DataBreadcrumb";
import { useEffect, useState } from "react";
import Layout from "src/components/Layout";
import NextHead from "src/components/Seo/NextHead";
import BreadcrumbComponent from "src/components/UserInterface/BreadcrumbComponent";
import BlogCard from "src/components/Blog/BlogCard";
import { BlogTitle } from "src/data/DataBlog";
import BlogCardSkeleton from "src/components/Blog/BlogCardSkeleton";
import { BlogOtherCategory } from "src/components/Blog/BlogOtherCategory";

const Category = ({ datas }) => {
  let query = datas.query["blog-category"].replace(/-/g, "_");

  const [blogData, setBlogData] = useState([]);
  const [isLoadingBlog, setIsLoadingBlog] = useState(true);

  const itemsForBreadCrumb = [
    ...blogBreadcrumb,
    {
      page: `${BlogTitle[query].title}`,
      href: `/blog/${BlogTitle[query].slug}`,
      to: `/blog/${BlogTitle[query].slug}`
    }
  ];

  const getBlogList = async (slug, limit) => {
    const { status, data } = await fetch(
      "GET",
      `/kentico/blog`,
      {
        limit: limit,
        slug: slug
      },
      true
    );
    if (status === 200) {
      setBlogData(data.item);
      setIsLoadingBlog(false);
    }
  };
  useEffect(() => {
    getBlogList(query, "");
    getBlogList("terpopuler", 5);
  }, []);

  return (
    <Layout>
      <NextHead
        title={`Blog - ${BlogTitle[query].title}`}
        description="Temukan artikel - artikel menarik mengenai keuangan dan gaya hidup di sini. Selalu update setiap minggu."
        url={`/blog/${query}`}
        breadcrumb={datas.breadcrumb}
      />
      <BreadcrumbComponent
        maxWidth="1006px"
        items={query && itemsForBreadCrumb}
      />
      <div className="blog-category-wrapper">
        <div className="blog-category-container">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p className="category">{query && BlogTitle[query].title}</p>
            <div className="blog-items-container">
              <div className="blog-items">
                {isLoadingBlog ? (
                  <BlogCardSkeleton />
                ) : (
                  blogData.map((data, key) => {
                    return (
                      <div key={key}>
                        <BlogCard
                          key={data.slug}
                          thumbnail={data.thumbnail}
                          title={data.title}
                          excerpt={data.excerpt}
                          slug={data.slug}
                          tags={data.tags}
                          previousPageTitle={BlogTitle[query].title}
                          previousPageSlug={BlogTitle[query].slug}
                        />
                      </div>
                    );
                  })
                )}
              </div>
              <BlogOtherCategory></BlogOtherCategory>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .blog-category-wrapper {
          display: flex;
          justify-content: center;
        }
        .blog-category-container {
          display: flex;
          max-width: 1040px;
        }
        .blog-items {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: wrap;
        }
        .category {
          font-size: 34px;
          margin: 16px;
        }
        .blog-items-container {
          display: flex;
        }
        .artikel-populer {
          margin-top: 64px;
        }
        .artikel-populer p {
          margin: 0 0 16px 10px;
          font-weight: bold;
          color: #676767;
          font-size: 17px;
        }
        .kategori-lainnya {
          margin-left: 10px;
        }
        .kategori-lainnya p {
          font-weight: bold;
          color: #676767;
          font-size: 17px;
          margin-top: 0;
        }
        .kategori-lainnya div {
          display: flex;
          flex-direction: column;
        }
        @media only screen and (max-width: 600px) {
          .blog-list-container {
            flex-direction: column;
          }
          .artikel-populer-wrapper {
            margin-left: 16px;
          }
          .blog-category-container {
            flex-direction: column;
          }
          .blog-items-container {
            flex-direction: column;
          }
          .blog-items {
            justify-content: center;
          }
          .category {
            font-size: 24px;
          }
        }
      `}</style>
    </Layout>
  );
};

Category.getInitialProps = async ({ asPath, query }) => {
  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + "/blog",
        name: "Blog"
      }
    },
    {
      "@type": "ListItem",
      position: "3",
      item: {
        "@id": process.env.baseUrl + asPath,
        name: query["blog-category"]
      }
    }
  ];

  return {
    datas: {
      asPath,
      breadcrumb,
      query
    }
  };
};

export default Category;
